import React from 'react';
import "./assets/css/_global.scss";
import { Routers } from './presentation/routers';
import { SnackbarProvider } from '@projectaltair/snackbarprovider'
import { QueryClient, QueryClientProvider } from 'react-query';
import { PopupProvider } from './config/utils/usePopup';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false
    }
  }
});

function App() {
  return (
    <PopupProvider>
      <SnackbarProvider>
        <QueryClientProvider client={queryClient}>
          <Routers />
        </QueryClientProvider>
      </SnackbarProvider>
    </PopupProvider>
    
  );
}

export default App;
